// extracted by mini-css-extract-plugin
module.exports = {"carousel":"pGuj7gl5Ydcq"};